/**
 * Resolves tailwind color names to native css color values
 */
export function colorToCss(val?: string): string | undefined {
    if (!val) return undefined;

    return `rgb(var(--colors-${val}))`;
}
